import { Box, Flex } from '@chakra-ui/react';

interface PassesSwitchFieldProps {
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  leftLabel?: string;
  rightLabel?: string;
}

const ACTIVE_PILL_EXTRA = '10px';

const PassesSwitchField = ({
  value,
  onChange,
  disabled = false,
  leftLabel = 'Yes',
  rightLabel = 'No',
}: PassesSwitchFieldProps) => {
  return (
    <Box>
      <Flex
        w="260px"
        bg="#CAD3DB"
        borderRadius="25px"
        align="center"
        justify="space-between"
        h="38px"
        cursor={disabled ? 'not-allowed' : 'pointer'}
        opacity={disabled ? 0.5 : 1}
        border="2px solid #243644"
        position="relative"
      >
        <Flex
          align="center"
          justify="center"
          borderRadius="25px"
          bg={value ? 'white' : 'transparent'}
          color={value ? '#243644' : '#3A4A57'}
          fontWeight="500"
          p="4px 8px"
          h="38px"
          w="45%"
          position="absolute"
          left="-1"
          zIndex={value ? 2 : 1}
          boxShadow={value ? '0 2px 8px rgba(36, 54, 68, 0.22)' : 'none'}
          transition="all 0.2s ease"
          onClick={disabled ? undefined : () => onChange(!value)}
          whiteSpace="nowrap"
        >
          {leftLabel}
        </Flex>

        <Flex
          align="center"
          justify="center"
          borderRadius="25px"
          bg={!value ? 'white' : 'transparent'}
          color={!value ? '#243644' : '#3A4A57'}
          fontWeight="500"
          h="38px"
          w="65%"
          position="absolute"
          right="-1"
          zIndex={!value ? 2 : 1}
          boxShadow={!value ? '0 2px 8px rgba(36, 54, 68, 0.22)' : 'none'}
          transition="all 0.2s ease"
          onClick={disabled ? undefined : () => onChange(!value)}
          p="4px 8px"
          whiteSpace="nowrap"
        >
          {rightLabel}
        </Flex>
      </Flex>
    </Box>
  );
};

export default PassesSwitchField;
